var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.imgLoading,
          expression: "imgLoading"
        }
      ],
      ref: "bigBox",
      staticClass: "contract-view",
      on: {
        drop: function($event) {
          return _vm.dropData($event)
        },
        dragover: function($event) {
          $event.preventDefault()
        },
        mousedown: function($event) {
          $event.preventDefault()
          return _vm.pageMousedown($event)
        },
        mouseleave: function($event) {
          return _vm.pageLeave($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "slider-top",
          style: { top: _vm.isHiddenHeader == 1 ? "0px" : "60px" }
        },
        [
          _c("el-slider", {
            staticClass: "slider-bar",
            attrs: {
              value: _vm.scaleValue,
              step: 5,
              min: 50,
              max: 200,
              "show-input": ""
            },
            on: {
              input: function(val) {
                this$1.$emit("update:scaleValue", val)
              }
            }
          }),
          !_vm.isDetail
            ? [
                _vm._v(
                  "\n      当前文件：已设置 " +
                    _vm._s(_vm.signOwnerLen) +
                    " 个签署方，" +
                    _vm._s(_vm.signOwnerNum) +
                    "\n      个签署位置"
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm.showSmallBox
        ? _c("div", { staticClass: "small-box" }, [
            _c("div", {
              staticClass: "float-box",
              on: {
                mouseup: _vm.handleMoveStop,
                mouseleave: _vm.handleMoveStop,
                mousedown: _vm.handleMoveMousedown
              }
            }),
            _vm.url
              ? _c("img", { attrs: { src: _vm.url } })
              : _c("img", { attrs: { src: _vm.contractInfo.url } })
          ])
        : _vm._e(),
      _vm.url || _vm.contractInfo
        ? _c(
            "div",
            {
              staticClass: "big-box",
              style: "transform:scale(" + _vm.scaleValue / 100 + ");"
            },
            [
              _c(
                "div",
                { ref: "contBox", staticClass: "cont-box" },
                [
                  _vm.url
                    ? _c("img", {
                        key: _vm.page,
                        staticClass: "imgInfo",
                        attrs: {
                          onerror: "this.src='/images/logo/jzq-logo.png'",
                          src: _vm.url,
                          alt: "合同信息"
                        },
                        on: { load: _vm.handleImgLoad }
                      })
                    : _c("img", {
                        staticClass: "imgInfo",
                        attrs: {
                          onerror: "this.src='/images/logo/jzq-logo.png'",
                          src: _vm.contractInfo.url,
                          alt: "合同信息"
                        },
                        on: { load: _vm.handleImgLoad }
                      }),
                  _c("qifeng-sign", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.items > 1,
                        expression: "items > 1"
                      }
                    ],
                    ref: "qifengCom",
                    attrs: {
                      "contract-info": _vm.contractInfo,
                      qifengChapList: _vm.qifengChapList,
                      imgBox: _vm.imgBox,
                      scaleValue: _vm.scaleValue,
                      items: _vm.items
                    },
                    on: {
                      "update:contractInfo": function($event) {
                        _vm.contractInfo = $event
                      },
                      "update:contract-info": function($event) {
                        _vm.contractInfo = $event
                      },
                      updateQifeng: _vm._updateQifeng,
                      delQifeng: function(cindex) {
                        return _vm.$emit("delQifeng", cindex)
                      }
                    }
                  }),
                  _vm.showChapter && _vm.chapterList.length
                    ? _c(
                        "div",
                        { staticClass: "chapter-list" },
                        [
                          _vm.isCreate
                            ? [
                                _vm._l(_vm.chapterList, function(item) {
                                  return [
                                    item.page === _vm.page - 1 &&
                                    item.targetId === _vm.targetId
                                      ? _c(
                                          "div",
                                          {
                                            key: item.cindex,
                                            staticClass: "cachet-box",
                                            style: _vm.handleSetChapte(item),
                                            attrs: {
                                              "data-cindex": item.cindex
                                            }
                                          },
                                          [
                                            item.url
                                              ? [
                                                  _vm.isCreate
                                                    ? _c(
                                                        "div",
                                                        {
                                                          class: {
                                                            "qz-new": true,
                                                            draging:
                                                              _vm.cachetMove &&
                                                              _vm.currentIndex ===
                                                                item.cindex,
                                                            enterprise_qz_new:
                                                              item.signatoryUserType
                                                          },
                                                          style: {
                                                            width:
                                                              (item.signatoryUserType ===
                                                              1
                                                                ? 208
                                                                : 115) + "px",
                                                            height:
                                                              parseInt(
                                                                item.signatoryUserType ===
                                                                  1
                                                                  ? 230
                                                                  : 101
                                                              ) -
                                                              parseInt(
                                                                _vm.hideSignDate
                                                                  ? 22
                                                                  : 0
                                                              ) +
                                                              "px"
                                                          }
                                                        },
                                                        [
                                                          _c("a", {
                                                            staticClass:
                                                              "el-icon-error color-danger del-chapter del-chapter__sign",
                                                            attrs: {
                                                              href:
                                                                "javascript:void (0)"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.delChapter(
                                                                  item.cindex
                                                                )
                                                              }
                                                            }
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              on: {
                                                                "!mousedown": function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleCacheMousedown(
                                                                    $event,
                                                                    {
                                                                      currentIndex:
                                                                        item.cindex
                                                                    }
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "h1",
                                                                {
                                                                  style: {
                                                                    background: [
                                                                      undefined,
                                                                      null
                                                                    ].includes(
                                                                      item.batch
                                                                    )
                                                                      ? "#ffa7a7"
                                                                      : "#e6cc75"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "签署方"
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: [
                                                                    "con",
                                                                    {
                                                                      padding_top:
                                                                        item.forge
                                                                    }
                                                                  ],
                                                                  style: {
                                                                    height:
                                                                      item.signatoryUserType ===
                                                                      1
                                                                        ? 208 -
                                                                          parseInt(
                                                                            _vm.hideSignDate
                                                                              ? 22
                                                                              : 0
                                                                          ) +
                                                                          "px"
                                                                        : "",
                                                                    borderColor: [
                                                                      undefined,
                                                                      null
                                                                    ].includes(
                                                                      item.batch
                                                                    )
                                                                      ? "#ffa7a7"
                                                                      : "#e6cc75"
                                                                  }
                                                                },
                                                                [
                                                                  item.qsInfo
                                                                    ? _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "text"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                          " +
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "eclipse"
                                                                                )(
                                                                                  (item.forge
                                                                                    ? "经办人-"
                                                                                    : "") +
                                                                                    " " +
                                                                                    item.qsInfo
                                                                                )
                                                                              ) +
                                                                              "\n                        "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticStyle: {
                                                                              color:
                                                                                "#41cbb6"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            在各自收到的文件中，独自签署\n                          "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                ],
                                                                2
                                                              ),
                                                              _c("img", {
                                                                attrs: {
                                                                  src: require("../../assets/images/move-icon.png")
                                                                }
                                                              }),
                                                              _vm.hideSignDate
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "time",
                                                                      style: {
                                                                        color: [
                                                                          undefined,
                                                                          null
                                                                        ].includes(
                                                                          item.batch
                                                                        )
                                                                          ? "#ffa7a7"
                                                                          : "#e6cc75"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "日期：XXXX"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : [
                                                        _c(
                                                          "div",
                                                          {
                                                            class: {
                                                              "d-new": true,
                                                              "is-draging":
                                                                _vm.cachetMove &&
                                                                _vm.currentIndex ===
                                                                  item.cindex
                                                            }
                                                          },
                                                          [
                                                            _c("a", {
                                                              staticClass:
                                                                "el-icon-error color-danger del-chapter del-chapter__sign",
                                                              attrs: {
                                                                href:
                                                                  "javascript:void (0)"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.delChapter(
                                                                    item.cindex
                                                                  )
                                                                }
                                                              }
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                on: {
                                                                  "!mousedown": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleCacheMousedown(
                                                                      $event,
                                                                      {
                                                                        currentIndex:
                                                                          item.cindex
                                                                      }
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("img", {
                                                                  staticClass:
                                                                    "chapte-img",
                                                                  attrs: {
                                                                    src:
                                                                      item.url,
                                                                    "data-cindex":
                                                                      item.cindex
                                                                  }
                                                                }),
                                                                _vm.currentIndex ===
                                                                item.cindex
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "move",
                                                                      attrs: {
                                                                        src: require("../../assets/images/move-icon.png")
                                                                      }
                                                                    })
                                                                  : _vm._e()
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                ]
                                              : _vm._e(),
                                            !item.url && !_vm.isautomaticQian
                                              ? [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "chapte-postion",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.$message.info(
                                                            "请在右侧选择签章"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    签章位置\n                  "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "batch-settings",
                                                attrs: {
                                                  plain: "",
                                                  type: "primary",
                                                  size: "small"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.batchChapCurr(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("批量设置")]
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ]
                                })
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e(),
                  false
                    ? [
                        _vm.page > 1
                          ? _c(
                              "div",
                              {
                                ref: "pre",
                                staticClass: "pre",
                                style: { left: _vm.preLeft + "px" },
                                on: { click: _vm.handlePrePage }
                              },
                              [_c("i", { staticClass: "el-icon-arrow-left" })]
                            )
                          : _vm._e(),
                        _vm.page < _vm.items
                          ? _c(
                              "div",
                              {
                                ref: "next",
                                staticClass: "next",
                                style: {
                                  left:
                                    (_vm.nextLeft ? _vm.nextLeft : "") + "px"
                                },
                                on: { click: _vm.handleNextPage }
                              },
                              [_c("i", { staticClass: "el-icon-arrow-right" })]
                            )
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              )
            ]
          )
        : _vm._e(),
      _c("BatchSettingsPup", {
        attrs: {
          title: "印章批量设置",
          visible: _vm.VISI,
          width: "40%",
          appendToBody: true,
          VISI: _vm.VISI,
          items: _vm.items,
          BChapCurr: _vm.BChapCurr,
          "before-close": function(done) {
            _vm.VISI = false
            done()
          }
        },
        on: {
          "update:visible": function($event) {
            _vm.VISI = $event
          },
          BatchSettinsClose: _vm.BatchSettinsClose
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dcf4fd0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dcf4fd0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/contract-view/index.vue
// module id = s9eO
// module chunks = 2 3 6 8 14 35 36 44 45 46 49